import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CookiesProvider } from 'react-cookie';
import App from './App.jsx';
import ResiWebApp from './components/resiweb/ResiWebApp.jsx';
import { AuthProvider as ResiRentAuthProvider } from './context/AuthProvider';
import { AuthProvider as ResiWebAuthProvider } from './components/resiweb/context/AuthProvider';
import './i18n';

const container = document.getElementById('root');
const root = createRoot(container);

const isResiWeb = window.location.pathname.startsWith('/resiweb/');
if (isResiWeb) {
  require('./components/resiweb/i18n');
} else {
  require('./i18n');
}

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <CookiesProvider defaultSetOptions={{ path: '/' }}>
        <Routes>
          <Route
            path="/resiweb/:username/*"
            element={
              <ResiWebAuthProvider>
                <ResiWebApp />
              </ResiWebAuthProvider>
            }
          />
          <Route
            path="/*"
            element={
              <ResiRentAuthProvider>
                <App />
              </ResiRentAuthProvider>
            }
          />
        </Routes>
      </CookiesProvider>
    </BrowserRouter>
  </React.StrictMode>
);
